import type { Element, IPointerEvent } from '@antv/g6'
import { HoverActivate } from '@antv/g6'

export class HoverElement extends HoverActivate {
  getActiveIds(event: IPointerEvent<Element>) {
    const { model, graph } = this.context
    const { targetType, target } = event
    const targetId = target.id

    // console.log('target', target)

    const ids = []
    if (targetType === 'edge') {
      // const _edgeData = this.context.graph.getEdgeData(targetId)
      //   const edge = model.getEdgeDatum(targetId)
      //   ids.push(edge.source, edge.target)
    } else if (targetType === 'node') {
      const nodeData = this.context.graph.getNodeData(targetId)
      ids.push(...(nodeData?.relatedIds || []))

      const edges = this.context.graph.getEdgeData(ids)
      const style1 = {
        // stroke: '#5B8FF9',
        lineWidth: 2,
        lineDash: [5, 5],
      }
      const style2 = {
        // stroke: '#5B8FF9',
        lineWidth: 2,
        lineDash: [],
      }

      const updatedEdges = edges.map(edge => ({
        source: edge.source,
        target: edge.target,
        type: event.type === 'pointerenter' ? 'custom-cubic-horizontal' : 'cubic-horizontal',
        style: event.type === 'pointerenter' ? style1 : style2,
      }))

      graph.updateEdgeData(updatedEdges)
    }

    graph.frontElement(ids)
    return ids
  }
}
